import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const FilterBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '370px',
    minHeight: '650px',
    height: 'max-content',
    backgroundColor: palette.white,
    padding: '24px',
    borderRadius: '24px',
    /* position: 'sticky',
    top: '24px', */

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },
  };
});

export const FilterBlockHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    /* marginBottom: '20px', */
  };
});

export const FilterBlockHeaderFilters = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
  };
});

export const FilterBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',

    '> span': {
      color: '#857F8B',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '128%',
    },
  };
});

export const FilterBlockClear = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header_accent,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    cursor: 'pointer',
  };
});

export const FilterBlockDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '136%',
    whiteSpace: 'pre-line',
    marginBottom: '20px',
  };
});

export const Separator = styled(Box)({
  height: '1px',
  backgroundColor: palette.border.default,
  margin: '24px 0',
}) as typeof Box;
